
import React from 'react';
import { Send } from 'lucide-react';
import { type Gift, type Brand } from '@/utils/types';

interface ConvertActionProps {
  selectedGift: Gift;
  brands: Brand[];
}

const ConvertAction: React.FC<ConvertActionProps> = ({
  selectedGift,
  brands,
}) => {
  const getBrandName = (brandId: string) => {
    const brand = brands.find(b => b.id === brandId);
    return brand ? brand.name : 'Unknown';
  };

  const feeAmount = selectedGift.amount * 0.10;
  const netAmount = selectedGift.amount - feeAmount;

  return (
    <div className="space-y-4">
      <p className="text-sm text-muted-foreground">
        Convert your GivGo Bucks to cash in your Venmo account.
      </p>
      <div className="space-y-4">
        <div className="text-center p-3 border rounded-lg bg-blue-50">
          <p className="font-medium">{getBrandName(selectedGift.brandId)} GivGo Bucks → Venmo</p>
          <div className="flex items-center justify-center gap-2 mt-2">
            <p className="text-lg font-bold">${selectedGift.amount.toFixed(2)}</p>
            <Send className="h-4 w-4" />
            <p className="text-lg font-bold">${netAmount.toFixed(2)}</p>
          </div>
          <p className="text-xs text-muted-foreground mt-1">10% transaction fee applies (${feeAmount.toFixed(2)})</p>
        </div>
        
        <div className="p-3 border rounded-lg bg-gray-50">
          <p className="text-sm text-center">
            Cash will be sent to the Venmo account connected to your email address.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConvertAction;
